import React from 'react';
import { Button } from '@components';
import { Input, Typography } from 'gd-design-library';
import styles from './SignUpForm.module.scss';
import classNames from 'classnames/bind';
import { formFields } from './form';
import { useForm } from 'hooks';
import { Customer } from '@commercetools/platform-sdk';
import Link from 'next/link';
import { ROUTES } from '@constants';

const CN = 'sign-up-form';
const textClassName = `${CN}--text`;
const fieldsInRowClassName = `${CN}--fields-in-row`;
const fieldClassName = `${CN}--field`;
const buttonClassName = `${CN}--button`;
const signInClassName = `${textClassName}--sign-in`;

const cx = classNames.bind(styles);

interface Props {
  onSignUp: (customer: Customer) => void;
  showSignInLink?: boolean;
  isLoading: boolean;
  errorMessage?: string;
}

export const SignUpForm: React.FC<Props> = ({ onSignUp, isLoading, showSignInLink, errorMessage }) => {
  const {
    state,
    errors,
    handleChange,
    handleBlur,
    handleFocus,
    handleAutofill,
    getFormValidState
  } = useForm(formFields);

  return <form className={ cx(CN) }>
    <div className={ cx(fieldsInRowClassName) }>
      <Input
        required
        name='firstName'
        variant='text'
        label='First Name'
        value={ state.firstName }
        className={ cx(fieldClassName) }
        onAnimationStart={ handleAutofill }
        onFocus={ handleFocus }
        onBlur={ handleBlur }
        onChange={ handleChange }
        color={ errors.firstName.isTouched && !errors.firstName.isValid ? 'error' : 'primary' }
        helperText={ errors.firstName.isTouched && !errors.firstName.isValid? errors.firstName.message : '' }
      />
      <Input
        required
        name='lastName'
        variant='text'
        label='Last Name'
        value={ state.lastName }
        className={ cx(fieldClassName) }
        onAnimationStart={ handleAutofill }
        onFocus={ handleFocus }
        onBlur={ handleBlur }
        onChange={ handleChange }
        color={ errors.lastName.isTouched && !errors.lastName.isValid ? 'error' : 'primary' }
        helperText={ errors.lastName.isTouched && !errors.lastName.isValid? errors.lastName.message : '' }
      />
    </div>
    <Input
      required
      name='email'
      variant='email'
      label='Email'
      value={ state.email }
      className={ cx(fieldClassName) }
      onAnimationStart={ handleAutofill }
      onFocus={ handleFocus }
      onBlur={ handleBlur }
      onChange={ handleChange }
      color={ !!errorMessage || (errors.email.isTouched && !errors.email.isValid) ? 'error' : 'primary' }
      helperText={ errorMessage || (errors.email.isTouched && !errors.email.isValid ? errors.email.message : '') }
    />
    <Input
      required
      name='password'
      variant='password'
      label='Password'
      value={ state.password }
      className={ cx(fieldClassName) }
      onBlur={ handleBlur }
      onChange={ handleChange }
      color={ errors.password.isTouched && !errors.password.isValid ? 'error' : 'primary' }
      helperText={ errors.password.isTouched && !errors.password.isValid ? errors.password.message : '' }
      maxLength={ 20 }
    />
    <Button
      className={ cx(buttonClassName) }
      loading={ isLoading }
      onClick={ (): void => getFormValidState() && onSignUp(state as Customer) }
    >
      Sign Up
    </Button>
    { showSignInLink &&
      <Typography variant='h6' className={ cx(textClassName) }>
        Already have an account?
        <span className={ cx(signInClassName) }>
          <Link href={ ROUTES.signIn }>
              Sign In
          </Link>
        </span>
      </Typography>
    }
  </form>;
};
